import { Box, Checkbox, Divider, FormControlLabel, Stack } from "@mui/material";
import { useCallback } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { CheckboxField, StaticValueField } from "../../../components/Forms";
import { useMsg } from "../../../components/Msg/Msg";
import { useGamification } from "../../Gamification/GamificationProvider";

const userInputSx = { my: 3, p: 3, bgcolor: "#FCFCFD" };

export const SessionTodos = ({ name, rules, withoutControls }) => {
  const msg = useMsg();
  const { setValue, watch } = useFormContext();
  const { fields } = useFieldArray({ name, rules });
  const list = watch(name);
  const { handleGoalCompleted } = useGamification();

  const isAllChecked = !!list?.length && list.every((field) => field.checked);
  const handleCheckAll = useCallback(
    (e, value) => {
      list.forEach((field, i) => {
        setValue(`${name}.${i}.checked`, value);
      });
      if (value) handleGoalCompleted();
    },
    [list, handleGoalCompleted, setValue, name],
  );
  const onChange = (e, value) => {
    if (value) handleGoalCompleted();
  };

  // console.log("[SessionTodos.rndr]", { fields, list, isAllChecked });

  if (!list?.length) return null;

  return (
    <Stack sx={{ ...userInputSx }}>
      {fields.map(({ id, ...fieldDefaultValues }, i) => (
        <FormControlLabel
          key={id}
          control={
            <CheckboxField name={`${name}.${i}.checked`} onChange={onChange} />
          }
          label={<StaticValueField name={`${name}.${i}.label`} />}
        />
      ))}
      {!withoutControls && (
        <>
          <Divider sx={{ my: 2, opacity: 0.4 }} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  name="isAllChecked"
                  checked={!!isAllChecked}
                  onChange={handleCheckAll}
                />
              }
              label={msg("sessions.edit.steps.reflect.mark-all-as-completed")}
            />
          </Box>
        </>
      )}
    </Stack>
  );
};
